import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1831fe53&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=1831fe53&prod&scoped=true&lang=css&external"
import style1 from "./Notifications.vue?vue&type=style&index=1&id=1831fe53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1831fe53",
  null
  
)

export default component.exports